module.exports = __webpack_public_path__ + "img/rightside_1000.de1397a5.png";